import React from 'react';

import {useAccountSettingsState} from 'app/settings/api';
import {
  useSwitch,
  useToggleWidgetIsOpen,
  useWidgetIsOpenState,
} from 'app/settings/hooks';
import {SWEETAI_DASHBOARD_CHAT_WIDGET} from 'app/settings/slice';
import {gt} from 'app/utils/i18n';

import {ChatWidget} from './ChatWidget';

export function DashboardChatWidget() {
  const {account_id, account_email, require_ai_data_sharing_at} =
    useAccountSettingsState().data!;
  const toggleWidgetIsOpen = useToggleWidgetIsOpen();
  const isShowingChat = useWidgetIsOpenState({
    contentType: 'accountprofile',
    objectId: account_id,
    widgetName: SWEETAI_DASHBOARD_CHAT_WIDGET,
  });

  const rag = useSwitch('ragaccount');
  return (
    <>
      {rag && require_ai_data_sharing_at ? (
        <ChatWidget
          isHidingChat={!isShowingChat}
          toggleChat={() =>
            toggleWidgetIsOpen({
              contentType: 'accountprofile',
              objectId: account_id,
              widgetName: SWEETAI_DASHBOARD_CHAT_WIDGET,
            })
          }
          url={account_email}
          objectId={account_id}
          contentType={'accountprofile'}
          chatType={'ragaccount'}
          placeholder={gt(
            'Ask about your procedures and policies or how to use SweetProcess'
          )}
        />
      ) : null}
    </>
  );
}
